import React from "react";

const ResultCalculatorNot = ({mensaje}) => {
  return (
    <section id="results-calculator" className="py-4">
      <header>
        <h2 className="text-danger">
          {/* <span> */}
            Atención
            {/* </span> */}
        </h2>
      </header>
      <section
        id="institucional__contacto"
        className="container d-flex flex-no-wrapresultados-calculador"
      >
        <small>{mensaje}</small>
      </section>
    </section>
  );
};

export default ResultCalculatorNot;
